export default __webpack_public_path__ + "static/logo-footer-dcdb26643bf232fec929b706899535cb.png";